/* eslint-disable jsx-a11y/anchor-is-valid */
import { useEffect } from "react";
import { Outlet, Route, Routes } from "react-router-dom";
// import { Registration } from "./components/Registration";
import { ForgotPassword } from "./components/ForgotPassword";
import { Login } from "./components/Login";
import { toAbsoluteUrl } from "../../../_flyingPaws/helpers";
import { CreateNewPassword } from "./components/CreateNewPassword";

const AuthLayout = () => {
  useEffect(() => {
    document.body.classList.add("bg-body");
    return () => {
      document.body.classList.remove("bg-body");
    };
  }, []);

  return (
    <div
      className="d-flex flex-column flex-column-fluid position-x-center  bgi-attachment-fixed"
      style={{
        backgroundColor: "#004025",
        // backgroundImage: `url(${toAbsoluteUrl('/media/illustrations/sketchy-1/14.png')})`,
      }}
    >
      {/* begin::Content */}
      <div className="d-flex flex-center align-items-center justify-content-center flex-column flex-column-fluid p-10 pb-lg-45">
        <div
          style={{ backgroundColor: "#000F1E" }}
          className="w-lg-500px h-100 align-items-center justify-content-center  rounded shadow p-10 p-lg-15 mx-auto"
        >
          {/* begin::Logo */}
          <div className="d-flex flex-center align-items-center text-center justify-content-center flex-column flex-column-fluid">
            <a href="#" className="flex-center">
              <img
                alt="Logo"
                src={toAbsoluteUrl("/media/logos/default.svg")}
                className="h-60px mb-4"
              />
            </a>
            <img
              alt="Logo"
              src={toAbsoluteUrl("/media/logos/default-dark.svg")}
              className="h-20px mb-12 "
            />
          </div>
          {/* end::Logo */}
          {/* begin::Wrapper */}
          <div>
            <Outlet />
          </div>
          {/* end::Wrapper */}
        </div>
      </div>
      {/* end::Content */}
      {/* begin::Footer */}
      {/* <div className='d-flex flex-center flex-column-auto p-10'>
        <div className='d-flex align-items-center fw-bold fs-6'>
          <a href='#' className='text-muted text-hover-primary px-2'>
            About
          </a>

          <a href='#' className='text-muted text-hover-primary px-2'>
            Contact
          </a>

          <a href='#' className='text-muted text-hover-primary px-2'>
            Contact Us
          </a>
        </div>
      </div> */}
      {/* end::Footer */}
    </div>
  );
};

const AuthPage = () => (
  <Routes>
    <Route element={<AuthLayout />}>
      <Route path="login" element={<Login />} />
      {/* <Route path="registration" element={<Registration />} /> */}
      <Route path="forgot-password" element={<ForgotPassword />} />
      <Route path="set-password" element={<CreateNewPassword />} />
      <Route index element={<Login />} />
    </Route>
  </Routes>
);

export { AuthPage };
